// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3avJm","sendOtp":"AuthorizeToLogin_sendOtp__2w3sw"};